import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const WeekProvider = ({ children }) => {
  const [week, setWeek] = useState(null);
  const [weeks, setWeeks] = useState([]);

  const refresh = async () => {
    const { data } = await api.get("/weeks");
    setWeeks(data || []);
    setWeek((cur) => {
      if (!cur && data?.length) return data[0];
      if (cur && data && !data.includes(cur)) return data[0] || null;
      return cur;
    });
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, []);

  return (
    <Ctx.Provider value={{ week, setWeek, weeks, refresh }}>
      {children}
    </Ctx.Provider>
  );
};

export const useWeek = () => useContext(Ctx);
